export default "__VITE_ASSET__A4hH0SmC__"